module.exports = __webpack_public_path__ + "static/img/logo.f57724d.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/logo.png
// module id = fL8f
// module chunks = 71